import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';

export function postApplyCoupon(successCallback, errorCallback, data) {
  postAuth({
    "path": `apply-coupon`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}




